"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockCustomMenuResponse = void 0;
var mockCustomMenuResponse = {
  getCustomMenuResponse: {
    countryName: 'US',
    customOptions: [{
      abbreviation: 'Bake',
      id: 'B',
      options: [{
        abbreviation: 'Bake',
        isSelected: true,
        optionId: 1,
        value: 'Normal Bake'
      }, {
        abbreviation: 'Bake',
        isSelected: false,
        optionId: 2,
        value: 'Well Done'
      }],
      title: 'Bake'
    }, {
      abbreviation: 'Cheese',
      id: 'C',
      options: [{
        abbreviation: 'CHZ',
        isSelected: true,
        optionId: 1,
        value: 'Cheese'
      }, {
        abbreviation: 'CHZ',
        isSelected: false,
        optionId: 2,
        value: 'No Cheese'
      }, {
        abbreviation: 'CHZ',
        isSelected: false,
        optionId: 3,
        value: 'Light Cheese'
      }],
      title: 'Cheese'
    }, {
      abbreviation: 'Sauce',
      id: 'S',
      options: [{
        abbreviation: 'S',
        isSelected: false,
        optionId: 1,
        value: 'Light Sauce'
      }, {
        abbreviation: 'S',
        isSelected: true,
        optionId: 2,
        value: 'Normal Sauce'
      }, {
        abbreviation: 'S',
        isSelected: false,
        optionId: 3,
        value: 'Extra Sauce'
      }, {
        abbreviation: 'S',
        isSelected: false,
        optionId: 4,
        value: 'No Sauce'
      }],
      title: 'Sauce'
    }, {
      abbreviation: 'Cut',
      id: 'CO',
      options: [{
        abbreviation: 'Cut',
        isSelected: true,
        optionId: 1,
        value: 'Standard Cut'
      }, {
        abbreviation: 'Cut',
        isSelected: false,
        optionId: 2,
        value: 'No Cut'
      }],
      title: 'Cut Option'
    }],
    helpUUID: null,
    images: null,
    menuTypes: [{
      itemType: '',
      menuItems: [{
        bannerPositionCode: null,
        calories: 1710,
        caloriesRange: '',
        comment: '',
        crustImages: null,
        cvItemId: 202100,
        favoriteId: 0,
        favoriteName: null,
        foodGroup: 'Pizza',
        franchiseStoreId: 77770001,
        freeToppings: 0,
        halfToppings: 0,
        id: 0,
        imageName: 'CrustImages.Whole.MTO-14TCP.2.png',
        imageUrl: null,
        imageUUID: '30f6bf80-9301-466a-9b89-ac67cacf2c90',
        isCustomizable: true,
        isCustomMenuItem: false,
        itemCaloriesText: '1710 Cal',
        itemDescription: 'Thin Crust',
        itemId: 202100,
        itemName: 'Thin Crust',
        itemPriceId: 0,
        itemType: '',
        maxchargedToppings: 0,
        maxToppings: 16,
        menuItemCode: 'MTO-14TCP',
        menuItemHasBanner: false,
        menuWarnings: null,
        menuItemHighlighted: 1,
        minToppings: 0,
        orderable: true,
        plu: 202100,
        price: 6,
        quantity: 0,
        secondsUntilUnavailable: 0,
        selectedCustomOptions: null,
        selectedCustomOptionsText: null,
        selectedToppings: null,
        selectedToppingsText: null,
        sortOrder: 1,
        toppingPrice: 0,
        toppings: null,
        toppingsGroupId: 1,
        toppingsThresholdCount: 0,
        toppingsThresholdMessage: '',
        totalServings: 1,
        webImages: null
      }, {
        bannerPositionCode: null,
        calories: 2000,
        caloriesRange: '',
        comment: '',
        crustImages: null,
        cvItemId: 102000,
        favoriteId: 0,
        favoriteName: null,
        foodGroup: 'Pizza',
        franchiseStoreId: 77770001,
        freeToppings: 1,
        halfToppings: 0,
        id: 0,
        imageName: 'CrustImages.Whole.MTO-14CP.2.png',
        imageUrl: null,
        imageUUID: '226830dc-6751-469d-b6dc-948b283ae92c',
        isCustomizable: true,
        isCustomMenuItem: false,
        itemCaloriesText: '2000 Cal',
        itemDescription: 'Round',
        itemId: 102000,
        itemName: 'Round',
        itemPriceId: 0,
        itemType: '',
        maxchargedToppings: 0,
        maxToppings: 40,
        menuItemCode: 'MTO-14CP',
        menuItemHasBanner: false,
        menuWarnings: null,
        menuItemHighlighted: 0,
        minToppings: 1,
        orderable: true,
        plu: 102000,
        price: 6.99,
        quantity: 0,
        secondsUntilUnavailable: 0,
        selectedCustomOptions: null,
        selectedCustomOptionsText: null,
        selectedToppings: null,
        selectedToppingsText: null,
        sortOrder: 0,
        toppingPrice: 0,
        toppings: null,
        toppingsGroupId: 1,
        toppingsThresholdCount: 0,
        toppingsThresholdMessage: '',
        totalServings: 1,
        webImages: null
      }],
      numberOfItems: 4,
      typeDescription: 'Pizzas'
    }],
    numberOfTypes: 1,
    status: {
      statusCode: 200,
      statusDisplay: 'OK',
      statusValue: true,
      version: 2,
      httpStatusCode: 0
    },
    toppingHighlight: null,
    toppings: [{
      abbr: 'B',
      column: 1,
      countsas: 1,
      crustToppingImages: null,
      left: null,
      maxLevel: 0,
      menuItemCodes: [{
        maxLevel: 0,
        menuItemCode: 'MTO-14CP'
      }, {
        maxLevel: 0,
        menuItemCode: 'MTO-14TCP'
      }, {
        maxLevel: 0,
        menuItemCode: 'MTO-DDDCP'
      }, {
        maxLevel: 0,
        menuItemCode: 'MTO-14SCP'
      }],
      nameDisabledImage: null,
      nameHighlightedImage: null,
      nameImage: null,
      plu: 0,
      price: 0,
      right: null,
      row: 0,
      toppingCode: 'TOP-BAC',
      toppingDescription: '',
      toppingDisabledImage: null,
      toppingGroupName: '',
      toppingId: 0,
      toppingImage: '467a40dc-c6a0-4c0b-9c51-0a52d9a35290',
      toppingIndex: 5,
      toppingItemCode: '110006',
      toppingLayerOrder: 10,
      toppingName: 'Bacon',
      toppingShortName: 'B',
      toppingSmallImage: null,
      toppingStatus: 0
    }, {
      abbr: 'BF',
      column: 3,
      countsas: 1,
      crustToppingImages: null,
      left: null,
      maxLevel: 0,
      menuItemCodes: [{
        maxLevel: 0,
        menuItemCode: 'MTO-14CP'
      }, {
        maxLevel: 0,
        menuItemCode: 'MTO-14TCP'
      }, {
        maxLevel: 0,
        menuItemCode: 'MTO-DDDCP'
      }, {
        maxLevel: 0,
        menuItemCode: 'MTO-14SCP'
      }],
      nameDisabledImage: null,
      nameHighlightedImage: null,
      nameImage: null,
      plu: 0,
      price: 0,
      right: null,
      row: 0,
      toppingCode: 'TOP-BFT',
      toppingDescription: '',
      toppingDisabledImage: null,
      toppingGroupName: '',
      toppingId: 0,
      toppingImage: 'd67b5e7f-fabb-436b-8c22-3e92c12e004c',
      toppingIndex: 6,
      toppingItemCode: '110007',
      toppingLayerOrder: 11,
      toppingName: 'Seasoned Beef',
      toppingShortName: 'BF',
      toppingSmallImage: null,
      toppingStatus: 0
    }]
  },
  succeeded: true
};
exports.mockCustomMenuResponse = mockCustomMenuResponse;